const enCategory = {
  category: {
    label: {
      name: "Name",
    },

    action: {
      cancel: "Cancel",
      edit: "Edit category",
      create: "Create category",
      delete: "Delete category",
      loading: "Loading category",
    },

    hints: {
      delete: "Do you really want to delete this category?",
    },

    messages: {
      successfullyCreated: "Category created successfully",
      successfullyEdited: "Category edited successfully",
      successfullyDeleted: "Category removed successfully",
    },
  },
};

export default enCategory;
